import { useState } from "react";

import dayjs from "@/utils/date";

import { useInterval } from "./useInterval";

const useNow = (interval: number | null) => {
  const [now, setNow] = useState(dayjs());
  useInterval(() => {
    setNow(dayjs());
  }, interval);

  return now;
};

export default useNow;
